import { render, staticRenderFns } from "./B-Chamber.vue?vue&type=template&id=c2420a9a&scoped=true&"
import script from "./B-Chamber.vue?vue&type=script&lang=js&"
export * from "./B-Chamber.vue?vue&type=script&lang=js&"
import style0 from "./B-Chamber.vue?vue&type=style&index=0&id=c2420a9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2420a9a",
  null
  
)

export default component.exports